import { IComboGroupState } from './comboGroupContext';
import { ComboGroupActionTypes, TComboGroupAction } from './comboGroupActions';

export const comboGroupReducer = (state: IComboGroupState, action: TComboGroupAction): IComboGroupState => {
	switch (action.type) {
		case ComboGroupActionTypes.SET_COMBO_GROUPS:
			return {
				...state,
				comboGroups: action.payload.comboGroups,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case ComboGroupActionTypes.CHANGE_SEARCH_STRING:
			return {
				...state,
				searchString: action.payload.searchString,
				currentPage: 1,
			};
		case ComboGroupActionTypes.SET_ID_SELECTED_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				IDSelectedRestaurant: null,
				IDSelectedDish: null,
				currentPage: 1,
			};
		case ComboGroupActionTypes.SET_ID_SELECTED_RESTAURANT:
			return {
				...state,
				IDSelectedRestaurant: action.payload.IDSelectedRestaurant,
				IDSelectedDish: null,
				currentPage: 1,
			};
		case ComboGroupActionTypes.SET_ID_SELECTED_DISH:
			return {
				...state,
				IDSelectedDish: action.payload.IDSelectedDish,
				currentPage: 1,
			};
		case ComboGroupActionTypes.RESET_SELECTED_CONTROLS:
			return {
				...state,
				searchString: '',
				IDSelectedCustomer: null,
				IDSelectedRestaurant: null,
				IDSelectedDish: null,
				currentPage: 1,
			};
		case ComboGroupActionTypes.SET_SORT_BY:
			return {
				...state,
				sortBy: action.payload.sortBy,
				currentPage: 1,
			};
		case ComboGroupActionTypes.SET_COUNT_OF_ITEMS:
			return {
				...state,
				countOfItems: action.payload.countOfItems,
				currentPage: 1,
			};
		case ComboGroupActionTypes.CHANGE_CURRENT_PAGE:
			return {
				...state,
				currentPage: action.payload.currentPage,
			};
		case ComboGroupActionTypes.SET_ID_FOR_DELETION:
			return {
				...state,
				IDForDeletion: action.payload.IDForDeletion,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case ComboGroupActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case ComboGroupActionTypes.SET_FILTERS_FROM_QUERY_STRING:
			return {
				...state,
				...action.payload.filters,
			};
		default:
			return state;
	}
};
